/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgChartTile = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        clipRule="evenodd"
        d="M4 6h2V4H4zm3 0h2V4H7zm3 0h2V4h-2zm3.454 12.672c.757 1.024 1.867 1.536 3.328 1.536s2.57-.512 3.328-1.536 1.136-2.517 1.136-4.48c0-3.915-1.488-5.872-4.464-5.872s-4.464 1.957-4.464 5.872c0 1.963.378 3.456 1.136 4.48zM18.27 17.2c-.32.65-.816.976-1.488.976s-1.168-.325-1.488-.976c-.32-.65-.48-1.653-.48-3.008 0-1.333.155-2.304.464-2.912.32-.619.821-.928 1.504-.928s1.179.31 1.488.928c.32.608.48 1.579.48 2.912 0 1.355-.16 2.357-.48 3.008zm-14.47.16v2.128c.427.224.939.4 1.536.528a9.221 9.221 0 0 0 1.904.192c.864 0 1.616-.16 2.256-.48.65-.32 1.152-.768 1.504-1.344.352-.587.528-1.27.528-2.048 0-1.11-.341-1.979-1.024-2.608-.683-.64-1.616-.96-2.8-.96-.565 0-1.12.096-1.664.288l.288-2.496h4.528V8.528h-6.32L3.864 14l1.408 1.104c.725-.32 1.435-.48 2.128-.48.597 0 1.056.15 1.376.448.33.299.496.715.496 1.248 0 .555-.197.992-.592 1.312s-.933.48-1.616.48c-.544 0-1.11-.064-1.696-.192a7.329 7.329 0 0 1-1.568-.56z"
        fill="currentcolor"
        fillRule="evenodd"
      />
    </g>
  </Icon>
);
export { SvgChartTile as ChartTile };
